import { render, staticRenderFns } from "./storeAccount.vue?vue&type=template&id=651ae1a4&scoped=true"
import script from "./storeAccount.vue?vue&type=script&lang=js"
export * from "./storeAccount.vue?vue&type=script&lang=js"
import style0 from "./storeAccount.vue?vue&type=style&index=0&id=651ae1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651ae1a4",
  null
  
)

export default component.exports